module.exports = __webpack_public_path__ + "img/c61.66c4659c.png";